import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import "./FiltersPanel.scss";

const EMPTY_ARRAY = [];

export const FiltersPanel = ({
    value,
    onChange,
    onApply,
    onReset,
    onClose,
    conditions = EMPTY_ARRAY,
    dates = EMPTY_ARRAY,
    onConditionChange,
    onTargetGroupToggle,
    onTargetGroupSelectAll,
    selectedTargetGroups = EMPTY_ARRAY,
    onTargetGroupLvl1Toggle,
    selectedTargetGroupsLvl1 = EMPTY_ARRAY,
    schoolId,
}) => {
    const { t } = useTranslation("tests");
    const [search, setSearch] = useState("");
    const [filteredConditions, setFilteredConditions] = useState([]);
    const [targetGroupsLvl1, setTargetGroupsLvl1] = useState([]);

    // Обработчик выбора всех групп 2 уровня для конкретной группы 1 уровня
    const handleSelectAllLvl2 = (lvl1Group) => {
        const allLvl2Ids = lvl1Group.children.map((child) => child._id);
        const allSelected = allLvl2Ids.every((id) => selectedTargetGroups.includes(id));

        if (onTargetGroupSelectAll) {
            onTargetGroupSelectAll(allLvl2Ids, !allSelected);
        }
    };

    // Проверка, все ли группы 2 уровня выбраны для данной группы 1 уровня
    const isAllLvl2Selected = (lvl1Group) => {
        if (!lvl1Group.children || lvl1Group.children.length === 0) return false;
        return lvl1Group.children.every((child) => selectedTargetGroups.includes(child._id));
    };

    useEffect(() => {
        const data = conditions.filter((c) => c?.name.toLowerCase().indexOf(search.toLowerCase()) >= 0);
        setFilteredConditions(data);
    }, [conditions, search]);

    // Загружаем целевые группы
    useEffect(() => {
        (async () => {
            try {
                const { data } = await axios.get(`targetGroups/level1`);
                const schoolParam = schoolId ? `?schoolId=${schoolId}` : "";
                const groupsWithChildren = await Promise.all(
                    data.targetGroups.map(async (lvl1Group) => {
                        const lvl2Response = await axios.get(`targetGroups/level2/${lvl1Group._id}${schoolParam}`);
                        return {
                            ...lvl1Group,
                            children: lvl2Response.data.targetGroups || [],
                        };
                    }),
                );
                setTargetGroupsLvl1(groupsWithChildren);
            } catch (error) {
                console.error("Error loading target groups:", error);
            }
        })();
    }, [schoolId]);

    return (
        <div className="page" style={{ paddingTop: 0 }}>
            <div className="page__content">
                <h3>{t("select_parameters")}</h3>
                <div style={{ margin: "0 0 1rem" }}>
                    <button className="main-btn" onClick={onApply} style={{ marginBottom: "0.5rem" }}>
                        {t("apply_filter", { defaultValue: "Применить фильтр" })}
                    </button>
                    <button className="main-btn main-btn_outline" onClick={onReset}>
                        {t("reset_filter", { defaultValue: "Сбросить фильтр" })}
                    </button>
                </div>
                <div className="filters-panel__sex-row">
                    {[
                        { value: "", label: t("filter_all") },
                        { value: "1", label: t("filter_male") },
                        { value: "2", label: t("filter_female") },
                    ].map((opt) => (
                        <button
                            key={opt.value}
                            type="button"
                            className={`filters-panel__sex-btn${value.sex === opt.value ? " filters-panel__sex-btn--active" : ""}`}
                            onClick={() => onChange({ target: { name: "sex", value: opt.value } })}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
                <div className="filters-panel__age-group">
                    <label className="filters-panel__age-label">{t("filter_age")}</label>
                    <input
                        type="text"
                        name="years"
                        className="filters-panel__age-input"
                        defaultValue={value.years || ""}
                        onChange={(e) => onChange(e)}
                    />
                </div>
                {/* Целевые группы */}
                {targetGroupsLvl1.length > 0 && (
                    <div style={{ marginBottom: "1.5rem" }}>
                        <h3>{t("target_groups", { defaultValue: "Целевые группы" })}</h3>
                        <div className="list">
                            {targetGroupsLvl1.map((lvl1Group) => (
                                <div key={lvl1Group._id}>
                                    {/* Группа первого уровня с чекбоксом */}
                                    <div className="list__checkbox" style={{ padding: "0.5rem 0" }}>
                                        <input
                                            type="checkbox"
                                            id={`lvl1-${lvl1Group._id}`}
                                            checked={selectedTargetGroupsLvl1.includes(lvl1Group._id)}
                                            onChange={() => onTargetGroupLvl1Toggle && onTargetGroupLvl1Toggle(lvl1Group._id)}
                                        />
                                        <label htmlFor={`lvl1-${lvl1Group._id}`}>
                                            <div>
                                                <p style={{ fontSize: "18px", fontWeight: "500" }}>{lvl1Group.name}</p>
                                            </div>
                                        </label>
                                    </div>

                                    {/* Чекбокс "Выбрать все" */}
                                    {lvl1Group.children && lvl1Group.children.length > 0 && (
                                        <div
                                            style={{
                                                marginLeft: "1rem",
                                                marginBottom: "0.5rem",
                                            }}
                                        >
                                            <div className="list__checkbox">
                                                <input
                                                    type="checkbox"
                                                    id={`select-all-${lvl1Group._id}`}
                                                    checked={isAllLvl2Selected(lvl1Group)}
                                                    onChange={() => handleSelectAllLvl2(lvl1Group)}
                                                />
                                                <label htmlFor={`select-all-${lvl1Group._id}`}>
                                                    <div>
                                                        <p style={{ fontStyle: "italic", color: "#4a90e2" }}>
                                                            {t("select_all", { defaultValue: "Выбрать все" })}
                                                        </p>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    )}

                                    {/* Группы второго уровня (дочерние) */}
                                    <div
                                        style={{
                                            marginLeft: "1rem",
                                            marginBottom: "0.75rem",
                                            borderLeft: "3px solid #4a90e2",
                                            paddingLeft: "0.5rem",
                                        }}
                                    >
                                        {lvl1Group.children &&
                                            lvl1Group.children.length > 0 &&
                                            lvl1Group.children.map((lvl2Group) => (
                                                <div key={lvl2Group._id} className="list__checkbox">
                                                    <input
                                                        type="checkbox"
                                                        id={lvl2Group._id}
                                                        name={lvl2Group._id}
                                                        value={lvl2Group._id}
                                                        onChange={onTargetGroupToggle}
                                                        checked={selectedTargetGroups.includes(lvl2Group._id)}
                                                    />
                                                    <label htmlFor={lvl2Group._id}>
                                                        <div>
                                                            <p>{lvl2Group.name}</p>
                                                        </div>
                                                    </label>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Фильтр по методикам и дате */}
                {conditions.length > 0 && (
                    <div style={{ marginTop: "1.5rem" }}>
                        <h3>{t("choose_condition_and_date", { defaultValue: "Выберите методику и дату" })}</h3>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: "1rem",
                                gap: "1rem",
                            }}
                        >
                            <div className="search" style={{ flex: 1 }}>
                                <FaSearch
                                    style={{
                                        marginRight: "8px",
                                        color: "rgba(18, 36, 67, 0.6)",
                                    }}
                                />
                                <input
                                    id="search"
                                    type="text"
                                    name="search"
                                    placeholder={t("search_placeholder")}
                                    onChange={(e) => setSearch(e.target.value)}
                                    value={search}
                                />
                            </div>
                            {dates.length > 0 && (
                                <div>
                                    <select
                                        name="date"
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "22px",
                                            letterSpacing: ".02em",
                                            color: "#122443",
                                            padding: "8px",
                                        }}
                                        value={value.date}
                                        onChange={onChange}
                                    >
                                        <option value="">{t("not_chosen", { defaultValue: "Не выбрано" })}</option>
                                        {dates.map((date) => (
                                            <option key={date} value={date}>
                                                {date}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>

                        <div className="list">
                            {filteredConditions.map((condition) => (
                                <div
                                    id={condition._id}
                                    key={condition._id}
                                    onClick={() => onConditionChange && onConditionChange(condition._id)}
                                    className="list__item"
                                    style={
                                        value.condition === condition._id
                                            ? {
                                                  color: "#fff",
                                                  background: "linear-gradient(to left, #00c6ff, #0072ff)",
                                              }
                                            : {}
                                    }
                                >
                                    <p>{condition.name}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
